import { DragEvent } from 'react'

export const handleDrag = (e: DragEvent<HTMLElement>) => {
  e.preventDefault()
  e.stopPropagation()
}
export const handleDragIn = (e: DragEvent<HTMLElement>) => {
  e.preventDefault()
  e.stopPropagation()
}
export const handleDrop = (e: DragEvent<HTMLElement>, onDrop: (e: DragEvent<HTMLElement>) => void) => {
  e.preventDefault()
  e.stopPropagation()
  if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
    onDrop(e)
  }
}

export const useFileDragEvents = () => {
  return {
    handleDrag,
    handleDragIn,
    handleDrop
  } as const
}
